import { render, staticRenderFns } from "./UITd.vue?vue&type=template&id=f159d6de"
import script from "./UITd.vue?vue&type=script&lang=js"
export * from "./UITd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports